import { render, staticRenderFns } from "./Popovers.vue?vue&type=template&id=2a21f0e4"
import script from "./Popovers.vue?vue&type=script&lang=js"
export * from "./Popovers.vue?vue&type=script&lang=js"
import style0 from "./Popovers.vue?vue&type=style&index=0&id=2a21f0e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports